import { z } from "zod";

/**
 * Address search, for the appointment form on both clients.
 *
 * The provider lives behind the API (`api/src/lib/geocode.ts`), never in a
 * client: both clients need the same behaviour, the lookup is cached once, and
 * swapping the provider is one file. This schema is the whole contract.
 */

export const geoSearchQuery = z.object({
  /**
   * Three characters before anything is sent: below that every answer is a
   * continent, and the keystroke that gets typed next invalidates it anyway.
   */
  q: z.string().trim().min(3).max(200),
});
export type GeoSearchQuery = z.infer<typeof geoSearchQuery>;

/** One address a user can pick. The label is what lands in `location_address`. */
export interface GeoSuggestion {
  label: string;
  lat: number;
  lng: number;
}
